export enum Space4LeadsSystemApiEnum {
    SPACE4LEADS_API = 'SPACE4LEADS_API',
}
